import React from "react";
import { Image } from "react-bootstrap";
import "./Disclaimer.scss";

const Disclaimer = () => {

  return (
    <div className="dislciamer-content">
      <div className="grid">
        <Image
          src={process.env.REACT_APP_S3_IMAGE_PATH + "sub-page-bg.png"}
          className="grid"
        />
        <Image
          src={process.env.REACT_APP_S3_IMAGE_PATH + "noise.png"}
          className="grains"
        />
      </div>

      <div className="hero-content">
        <div className="text-content">
          <h3 className="title mb-0">
            TVK/VANRY token migration – Disclaimers
          </h3>

          <div className="text-contract">
            <p>
              Important information before interacting with the TVK/VANRY token
              swap smart contract
            </p>
            <p>
              Please read this information carefully before swapping your TVK
              tokens to VANRY tokens.
            </p>
            <ul>
              <li>
                The TVK/VANRY swap smart contract is an open-source protocol
                that is not endorsed or recommended by the operators of the
                website{" "}
                <a
                  href="http://swap.vanarchain.com"
                  
                  rel="noopener noreferrer"
                  className="green"
                >
                  swap.vanarchain.com
                </a>{" "}
                (the "Site"). You are responsible for any risks associated with
                using the migration smart contract.
              </li>
              <li>
                The migration smart contract allows TVK token holders to migrate
                their tokens to VANRY tokens for a period of 12 months from the
                time the smart contract is open for migration. After this time,
                it will not be possible to migrate TVK tokens to VANRY tokens.
              </li>
              <li>
                The migration smart contract system is accessed through Ethereum
                node providers or compatible Ethereum wallet applications. You
                can use the Site to read and display data from the migration
                smart contract and generate transaction messages, but the Site
                does not interact with the migration smart contract directly or
                conduct any transactions on your behalf.
              </li>
              <li>
                The migration smart contract has been audited by Immunebytes,
                but there is always the risk of hacking or other malicious
                activity. Transactions on the Ethereum blockchain are
                irreversible, so any TVK tokens you send to the migration smart
                contract cannot be returned or converted back to VANRY tokens.
              </li>
              <li>
                The migration smart contract has not been reviewed, approved,
                endorsed, or registered with any regulator or other governmental
                entity. The creators of the migration smart contract are not
                licensed by any regulator or other authority to provide any
                legal, financial, accounting, investment, or other advice or
                services.
              </li>
              <li>
                By interacting with the TVK/VANRY migration smart contract, you
                confirm that you have read, understood, and accepted the above
                information.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
